/* Conversion updates: small enhancements that sit alongside theme.js */
(function () {
  var banner = document.querySelector('.pdp-banner');
  if (!banner || banner.classList.contains('is-marquee')) return;
  var list = banner.querySelector('.pdp-banner__list');
  if (!list) return;
  var items = Array.prototype.slice.call(list.children);
  if (!items.length) return;
  items.forEach(function (item) {
    var clone = item.cloneNode(true);
    clone.classList.add('is-clone');
    clone.classList.remove('is-active');
    clone.setAttribute('aria-hidden', 'true');
    list.appendChild(clone);
  });
  banner.classList.add('is-marquee');
})();
